<template>
	<div class="main">
		<header class="page-title">
			<h2>Redirects</h2>
			<div class="ml-auto" v-if="userRoles.includes('redirects.create')">
				<button class="btn btn-md btn-primary" @click="showHelpModal">
					<i class="fas fa-question-circle"></i> Help
				</button>
				<button class="btn btn-md btn-success" @click.prevent="showModal(0,'create')">
					<i class="fas fa-plus"></i> New Redirect
				</button>
			</div>
		</header>

		<div v-if="loader" class="flex center text-center mb-1">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>

		<form v-if="!loader" class="list-filter flex box" method="get" :action="endPoint" ref="filterForm">
			<div class="two form-group">
				<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
				<select id="limit" name="limit" @change="onFormChange" v-model="selectedLimit">
					<option value="null">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>

			<div class="two form-group">
				<label for="type"><i class="fas fa-fw fa-archive"></i>Type</label>
				<select id="type" @change="onFormChange" name="type" v-model="selectedType">
					<option value="null">All</option>
					<option v-for="type in types" :value="type.value">{{ type.name }}</option>
				</select>
			</div>
			<div class="two form-group">
				<label for="status"><i class="fas fa-fw fa-archive"></i>Status</label>
				<select id="status" @change="onFormChange" name="status" v-model="selectedStatus">
					<option value="null">All</option>
					<option v-for="state in states" :value="state.name">{{ state.name }}</option>
				</select>
			</div>
			<div class="six form-group">
				<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
				<div class="input-group">
					<input id="filter" class="input-small" name="filter" type="text" placeholder="Filter in ..." v-model="urlParams.filter" @change="checkReset" @keyup="onFilterChange">
					<button class="btn btn-primary" @click="clearForm">Filter</button>
				</div>
			</div>
		</form>

		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th>Type</th>
						<th>Status</th>
						<th>From</th>
						<th>To</th>
						<th>Actions</th>
						<th>Created</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(redirect,index) in redirects">
						<td>{{ redirect.type }}</td>
						<td>
							<span class="badge badge-success" v-show="redirect.status === 'approved'"><i class="fas fa-check"></i> Approved</span>
							<span class="badge badge-warning" v-show="redirect.status === 'pending'"><i class="fas fa-question"></i> New</span>
							<span class="badge badge-danger" v-show="redirect.status === 'changed'"><i class="fas fa-question"></i> Awaiting Approval</span>
						</td>
						<td>{{redirect.url_from}}</td>
						<td>{{redirect.url_to}}</td>
						<td class="nowrap">
							<a href="#" class="btn btn-icon btn-success" title="Manage Approval" v-show="userRoles.includes('redirects.can_approve') && (redirect.status === 'pending' || redirect.status === 'changed')" @click.prevent="showModal(index,'approve')"><i class="fas fa-check"></i></a>
							<a href="#" class="btn btn-icon btn-primary" title="Edit" v-show="userRoles.includes('redirects.update') && !editedRedirects[redirect.id]" @click.prevent="showModal(index,'edit')"><i class="fas fa-pencil-alt"></i></a>
							<a href="#" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('redirects.delete') && !editedRedirects[redirect.id]" @click.prevent="deleteRedirect(redirect.id)"><i class="fas fa-trash"></i></a>
						</td>
						<td>{{redirect.name}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title" v-show="actionMethod === 'edit'">Edit Redirect</h4>
				<h4 class="modal-title" v-show="actionMethod === 'approve'">Manage Redirect Approval</h4>
				<h4 class="modal-title" v-show="actionMethod === 'create'">New Redirect</h4>
			</template>
			<template slot="body">
				<div class="card">
					<header class="card-header language-list" v-show="actionMethod === 'create'">
						<nav>
							<ul class="tabs">
								<li class="active"><a href="#">Singular Redirect</a></li>
								<!--								<li><a href="#">CSV Upload</a></li>-->
							</ul>
						</nav>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="type">Type</label>
							<select id="type" v-model="redirect.type">
								<option v-for="type in types" :value="type.value">{{ type.name }}</option>
							</select>
							<p class="input-error" v-if="errors.errors.type">{{ errors.errors.type }}</p>
						</div>
						<div class="form-group">
							<label for="url_from">From</label>
							<input id="url_from" type="text" v-on:keyup="getArticle"
								   :disabled="actionMethod === 'edit' && (redirect.redirect_id || redirect.status === 'approved')"
								   v-model="redirect.url_from">
							<p class="input-error" v-if="errors.errors.url_from">{{ errors.errors.url_from }}</p>
						</div>
						<div class="form-group">
							<label for="url_to">To</label>
							<input id="url_to" v-model="redirect.url_to" type="text">
							<p class="input-error" v-if="errors.errors.url_to">{{ errors.errors.url_to }}</p>
						</div>

						<div class="form-group" v-if="editedRedirects[redirect.redirect_id]" v-show="redirect.redirect_id">
							<label>Original redirect</label>
							<p>{{ editedRedirects[redirect.redirect_id].url_from }} => {{ editedRedirects[redirect.redirect_id].url_to }}</p>
						</div>
						<div class="form-group" v-show="post.postable_id">
							<label>{{post.postable_type}}:</label>
							<p>Archive <input type="checkbox" v-model="archive">
								<span v-show="redirect.postable_id">[PostableId: {{redirect.postable_id}}]</span>
								<span v-show="post.postable_id">[PostId: {{post.postable_id}}]</span> [ {{post.title}} ]
							</p>
						</div>
					</div>
					<!--					TODO enable this when the mass redirect part is done -->
					<!--					<div class="card mb-0" v-show="actionMethod === 'create'">-->
					<!--						<header class="card-header language-list">-->
					<!--							<nav>-->
					<!--								<ul class="tabs">-->
					<!--									<li class="active"><a href="#">Singular Redirect</a></li>-->
					<!--									<li><a href="#">CSV Upload</a></li>-->
					<!--								</ul>-->
					<!--							</nav>-->
					<!--						</header>-->
					<!--						<div class="card-body">-->
					<!--							<div class="form-group">-->
					<!--								<label for="new-csv-file">CSV File</label>-->
					<!--								<input id="new-csv-file" type="file">-->
					<!--							</div>-->
					<!--						</div>-->
					<!--					</div>-->
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a class="btn btn-md btn-success" href="#" v-show="actionMethod === 'edit'" @click.prevent="updateRedirect"><i class="fas fa-save"></i> Save Changes</a>
				<a class="btn btn-md btn-success" href="#" v-show="actionMethod === 'approve'" @click.prevent="approveRedirect"><i class="fas fa-check"></i> Approve Redirect</a>
				<a class="btn btn-md btn-success" href="#" v-show="actionMethod === 'create'" :disabled="validated === 0" @click.prevent="saveRedirect"><i class="fas fa-plus"></i> Add Redirect</a>
			</template>
		</modal>

		<modal @close="closeHelpModal" v-show="isHelpModalVisible">
			<template slot="header">
				<h4 class="modal-title">Help</h4>
			</template>
			<template slot="body">
				F1!!!! F1!!!!
			</template>
			<template slot="footer">
				<a @click="closeHelpModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Close</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from '../Modal/DefaultModal.vue';
	import Errors from '../../Utils/Errors.js';

	export default {
		components: {
			modal
		},
		props: {
			dataRedirects: {
				type: Array
			},
			dataEditedRedirects: {
				type: Object
			},
			dataUrlParams: {
				type: Object,
				required: false
			},
			dataEndpoint: {
				type: String
			},
		},
		data() {
			return {
				isModalVisible: false,
				isHelpModalVisible: false,
				redirects: this.dataRedirects,
				urlParams: this.dataUrlParams || {},
				selectedSite: this.$selectedSite,
				loader: false,
				endPoint: this.dataEndpoint,
				filterEnabled: this.dataUrlParams.filter && this.dataUrlParams.filter.length > 0,
				selectedLimit: this.dataUrlParams.limit ? this.dataUrlParams.limit : null,
				types: [
					{value: 300, name: '300 Multiple Choices'},
					{value: 301, name: '301 Permanent Redirect'},
					{value: 302, name: '302 Found'},
					{value: 303, name: '303 See Other'},
					{value: 304, name: '304 Not Modified'},
					{value: 305, name: '305 Use Proxy'},
					{value: 306, name: '306 Switch Proxy'},
					{value: 307, name: '307 Temporary Redirect'},
					{value: 308, name: '308 Permanent Redirect (experimental)'},
					{value: 410, name: '410 Page Gone'},
				],
				states: [
					{name: 'approved'},
					{name: 'changed'},
					{name: 'pending'},
				],
				selectedType: this.dataUrlParams.type ? this.dataUrlParams.type : null,
				selectedStatus: this.dataUrlParams.status ? this.dataUrlParams.status : null,
				userRoles: this.$currentUserRoles,
				redirect: {
					user_id: null,
					type: 301,
					url_from: null,
					url_to: null,
					status: null,
					redirect_id: null,
					postable_id: null,
					postable_type: null
				},
				editedRedirects: this.dataEditedRedirects,
				actionMethod: null,
				timer: null,
				post: {
					postable_id: null,
					title: null,
					postable_type: null
				},
				archive: true,
				validated: 0,
				errors: new Errors()
			}
		},
		methods: {
			showModal: function (id, method) {
				this.actionMethod = method;
				if (method !== 'create') {
					this.redirect = JSON.parse(JSON.stringify(this.redirects[id]));
				} // if
				if (method === 'approve') {
					this.archive = !!this.redirect.postable_id;
					this.getArticle();
				} // if
				this.isModalVisible = true;
			},
			closeModal: function () {
				this.redirect = {
					user_id: null,
					type: 301,
					url_from: null,
					url_to: null,
					status: null,
					redirect_id: null,
					postable_id: null,
					postable_type: null
				};
				this.post = {
					postable_id: null,
					title: null,
					postable_type: null
				};
				this.archive = true;
				this.isModalVisible = false;
				this.errors.errors = {};
			},
			showHelpModal: function () {
				this.isHelpModalVisible = true;
			},
			closeHelpModal: function () {
				this.isHelpModalVisible = false;
			},
			onFormChange: function () {
				this.loader = true;
				this.clearForm();
				this.$refs.filterForm.submit();
			},
			clearForm: function () {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === 'null' || $(inp).val() === null)
						inp.disabled = true;
				});
			},
			onFilterChange: function () {
				this.filterEnabled = this.urlParams.filter && this.urlParams.filter.length > 0;
			},
			checkReset: function () {
				if (this.urlParams.filter.length === 0) {
					this.onFormChange();
				}
			},
			updateRedirect: function () {
				let selectedSite = this.$selectedSite.slug;

				axios.put('/api/' + this.$selectedSite.slug + '/redirects/' + this.redirect.id, this.redirect)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('Redirect updated successfully', 'Success');
							setTimeout(function () {
								window.location.replace('/' + selectedSite + '/redirects');
							}, 1000);
						} else {
							this.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Redirect save failed.', 'Error');
					});
			},
			approveRedirect: function () {
				let selectedSite = this.$selectedSite.slug;

				axios.post('/api/' + this.$selectedSite.slug + '/redirects/approve/' + this.redirect.id, this.redirect)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('Redirect approved successfully', 'Success');
							setTimeout(function () {
								window.location.replace('/' + selectedSite + '/redirects');
							}, 1000);
						} else {
							this.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Redirect approve failed.', 'Error');
					});
			},
			saveRedirect: function () {
				let selectedSite = this.$selectedSite.slug;
				this.redirect.status = 'pending';

				if (this.archive) {
					this.redirect.postable_id = this.post.postable_id;
					this.redirect.postable_type = this.post.postable_type;
				} // if

				axios.post('/api/' + this.$selectedSite.slug + '/redirects', this.redirect)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('Redirect saved successfully', 'Success');
							setTimeout(function () {
								window.location.replace('/' + selectedSite + '/redirects');
							}, 1000);
						} else {
							this.$toastr.error(response.data.failed, 'Error');
						} // if
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Redirect save failed.', 'Error');
					});
			},
			deleteRedirect: function (id) {
				let vm = this;
				vm.$dialog.confirm('Are you sure you want to delete this Redirect?')
					.then((dialog) => {
						axios.delete('/api/' + this.$selectedSite.slug + '/redirects/' + id)
							.then(response => {
								vm.$toastr.success('Delete successful.');
								location.reload();
							})
							.catch(errors => {
								dialog.close();
								vm.$toastr.error('Delete failed.');
							});
					})
					.catch(error => {
						vm.$toastr.error('Delete aborted.');
					});
			},
			getArticle: function () {
				clearTimeout(this.timer);
				let urlFrom = {url: this.redirect.url_from},
					selectedSite = this.$selectedSite.slug,
					self = this;

				this.validated = 0;

				this.timer = setTimeout(function () {
					axios.post('/api/' + selectedSite + '/redirects/get_post/', urlFrom)
						.then(response => {
							self.post = response.data;
							self.validated = 1;
						})
						.catch(e => {
							this.$toastr.error('Get Article failed.', 'Error');
						});
				}, 1500);

			}
		}
	}
</script>
